import classNames from "classnames";
import Checkbox from "@mui/material/Checkbox";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import ViewColumn from "@mui/icons-material/ViewColumn";
import { STATIC_STRINGS } from "@asez/shared";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import { useMemo, useState } from "react";
import { isEmpty } from "../../../../utils";
import { INPUT_VARIANTS, SIZES } from "@asez/shared";
import {GenericInput} from "@asez/component-library";

import { FilterMenu } from "./FilterMenu";
import useMediaQueryScreen from "../../../../hooks/useMediaQueryScreen";

const RenderHeader = ({
  applyFilters,
  selectedRows,
  gridData,
  visibleColumns,
  searchTerm,
  updateSearchTerm,
  initialColumns,
  updateVisibleColumns,
}: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { screen, screenProps } = useMediaQueryScreen();
  const isSendEmailDisabled = useMemo(() => {
    if (!isEmpty(selectedRows)) {
      return selectedRows.some(
        (id) => gridData.find((d) => d.id === id)?.scorePercentage !== null
      );
    } else {
      return true;
    }
  }, [selectedRows, gridData]);

  const handleColumnToggle = (column: any) => {
    updateVisibleColumns(
      (prev) =>
        prev.some((c) => c.key === column.key)
          ? prev.filter((c) => c.key !== column.key) // Remove if exists
          : [...prev, column] // Add if not exists
    );
  };

  return (
    <div className="flex justify-between items-center mt-1 mb-4 col-12">
      <GenericInput
        label={STATIC_STRINGS.CANDIDATE_SEARCH_PLACEHOLDER}
        type="text"
        variant={INPUT_VARIANTS.outlined}
        size={SIZES.sm}
        className="w-1/3"
        value={searchTerm}
        onChange={(e) => updateSearchTerm(e.target.value)}
      />
      <div className="flex gap-2">
        <Tooltip
          title={
            isSendEmailDisabled
              ? STATIC_STRINGS.TOOLTIP_MESSAGES.EMAIL_REMAINDER_DISABLED
              : STATIC_STRINGS.TOOLTIP_MESSAGES.EMAIL_REMAINDER
          }
        >
          <button
            className={classNames(
              "btn button-padding p-1 flex items-center justify-center",
              isSendEmailDisabled ? "btn-primary-disabled" : "btn-primary"
            )}
            disabled={isSendEmailDisabled}
          >
            <EmailOutlinedIcon
              fontSize={!screenProps.is_largeplus ? "small" : "medium"}
            />
          </button>
        </Tooltip>

        <Tooltip title={STATIC_STRINGS.TOOLTIP_MESSAGES.SELECT_COLUMNS}>
          <button
            className="btn btn-outline button-padding p-1 flex items-center justify-center text-neutral-dark"
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            <ViewColumn
              fontSize={!screenProps.is_largeplus ? "small" : "medium"}
            />
          </button>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          slotProps={{
            paper: {
              sx: {
                maxWidth: "250px",
                width: "100%",
              },
            },
          }}
        >
          {initialColumns.map((col) => (
            <Tooltip key={col.key} title={col.label}>
              <MenuItem key={col.key} onClick={() => handleColumnToggle(col)}>
                <Checkbox
                  checked={visibleColumns.some((vc) => vc.key === col.key)}
                  sx={{
                    color: "var(--color-neutral-dark)",
                    "&.Mui-checked": {
                      color: "var(--color-neutral-dark)",
                    },
                  }}
                />
                <span className="text-ellipsis overflow-hidden">
                  {col.label}
                </span>
              </MenuItem>
            </Tooltip>
          ))}
        </Menu>
        <FilterMenu applyFilters={applyFilters} />
      </div>
    </div>
  );
};

export default RenderHeader;
